module.exports = __webpack_public_path__ + "static/media/Teil_3_Neu_Backward.81084ad5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_3_Neu_Backward.mp4
// module id = 116
// module chunks = 0